<mat-dialog-content>

  <div class="flex flex-col items-center w-full scrollable-div">
    <div class="flex flex-col rounded-lg w-11/12" style="padding: 20px;">
      <span>
        Edit business information
      </span>
      <hr style="border: 1px solid gray;">
      <br />
      <form [formGroup]="businessForm">
        <div class="flex flex-row rounded-lg w-full">
          <div class="flex flex-col rounded-lg w-1/2">
            <h3>{{currentBusiness.businessName}}</h3>
            <hr style="border: 1px solid gray;">

            <div class="flex flex-row w-full">
              <div class="flex flex-col w-full">
                <span>
                  {{currentBusiness.businessAddress1}}
                </span>
                <span>{{currentBusiness.businessCity + ' ' +
                  currentBusiness.businessZip}}</span>
              </div>
            </div>

            <table class="w-full">
              <tr style="padding-bottom: 10px;">
                <th>Business ID:</th>
                <td>{{currentBusiness.id}} </td>
              </tr>
              <tr>
                <th>Type:</th>
                <td>{{businessType(currentBusiness.businessType)}} 
                </td>
              </tr>
              <tr>
                <th>Status: </th>
                <td>
                  <span *ngIf="currentBusiness.active" style="color: green;">Active</span>
                  <span *ngIf="!currentBusiness.active" style="color: red;">Inactive</span>
                </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Exempt:</th>
                <td>{{currentBusiness.exempt ? 'Yes':'No'}} </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Exempt:</th>
                <td>
                  <span *ngIf="!currentBusiness.exempt" style="color: red;font-weight: bold;">No</span>
                  <div *ngIf="currentBusiness.exempt">
                    <span style="color:green;font-weight: bold;"> Yes <mat-icon matTooltip="Info" (click)="showInfo()">info-sign</mat-icon>
                    </span>
                    <table *ngIf="showInformation" class="w-full">
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Certification Date:</th>
                        <td style="color:green;">{{currentBusiness.exemptCertificateDate}} </td>
                      </tr>
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Status:</th>
                        <td style="color:green;">{{currentBusiness.exemptStatus}} </td>
                      </tr>
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Type:</th>
                        <td style="color:green;">{{currentBusiness.exemptType}} </td>
                      </tr>
                      <tr>
                        <th style="color:green;">Cigarette Smoking Allowed:</th>
                        <td>
                          <span *ngIf="currentBusiness.exemptSmokingAllowed" style="color:green;">Yes</span> 
                          <span *ngIf="!currentBusiness.exemptSmokingAllowed" style="color:red;">No</span> 
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>

              <tr style="padding-bottom: 10px;">
                <th>County:</th>
                <td>{{currentBusiness.countyName}} </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Business Phone:</th>
                <td>{{currentBusiness.businessPhone + ' ' + (currentBusiness.businessPhoneExt == '' ? '' : ' +' + currentBusiness.businessPhoneExt)}} </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Business Owner:</th>
                <td>{{currentBusiness.businessOwner}} </td>
              </tr>
            </table>

            <div>
              <mat-form-field>
                <mat-label>Business Phone</mat-label>
                <input matInput formControlName="businessPhone">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Business Phone Ext.</mat-label>
                <input matInput formControlName="businessPhoneExt" matTooltip="Ext.">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Contact Title</mat-label>
                <input matInput formControlName="contactTitle">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Contact Email</mat-label>
                <input matInput formControlName="contactEmail">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Business Owner</mat-label>
                <input matInput formControlName="businessOwner">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Owner Title</mat-label>
                <input matInput formControlName="businessOwnerTitle">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Owner Phone</mat-label>
                <input matInput formControlName="businessOwnerPhone">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Owner Email</mat-label>
                <input matInput formControlName="businessOwnerEmail">
              </mat-form-field>
            </div>

          </div>

          <div class="flex flex-col rounded-lg w-1/2">
            <h3>Registered Agent</h3>
            <hr style="border: 1px solid gray;">
            <div>
              <mat-form-field>
                <mat-label>Registered Agent ID</mat-label>
                <input matInput formControlName="parentBusinessId">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Registered Agent Name</mat-label>
                <input matInput formControlName="parentBusinessName">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Contact First Name</mat-label>
                <input matInput formControlName="parentBusinessContactFirstName">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Contact Last Name</mat-label>
                <input matInput formControlName="parentBusinessContactLastName">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Contact Title</mat-label>
                <input matInput formControlName="parentBusinessContactTitle">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Address</mat-label>
                <input matInput formControlName="parentBusinessAddress">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Address 2</mat-label>
                <input matInput formControlName="parentBusinessAddress2">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="parentBusinessCity">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="parentBusinessState">
                  <mat-option *ngFor="let list of stateList" [value]="list">
                    {{list}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Zip</mat-label>
                <input matInput formControlName="parentBusinessZip">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Zip Ext.</mat-label>
                <input matInput formControlName="parentBusinessZipExt" matTooltip="Ext.">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Phone</mat-label>
                <input matInput formControlName="parentBusinessPhone">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Phone Ext</mat-label>
                <input matInput formControlName="parentBusinessPhoneExt" matTooltip="Ext.">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput formControlName="parentBusinessEmail">
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox formControlName="useParentBusinessContact">Use Registered Agent as Primary Contact</mat-checkbox>
            </div>
          </div>

        </div>
      </form>
      <div class="flex flex-row" style="align-items: flex-start;">
        <div style="padding-right: 20px;">
          <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
            Save
          </button>
        </div>
        <div style="padding-right: 20px;">
          <button mat-raised-button (click)="return()" class="m-8 container">
            Return
          </button>
        </div>
      </div>

    </div>
    <br />
    <hr style="border: 1px solid gray;">
  </div>

</mat-dialog-content>